import { h } from "preact";

import { classNames } from "../helpers.js";

import Avatar from "./Avatar.jsx";
import IconButton from "./IconButton.jsx";
import UserSelectorPullout from "./UserSelectorPullout.jsx";
import Dropdown from "./Dropdown.jsx";

export default function UserSelector({
  label,
  recruiters,
  placeholder,
  ...props
}) {
  function handleChange(newIds) {
    props.onInput(newIds);
  }

  return (
    <div class={classNames("user-selector", props.class)}>
      <h5 class="t-overline mb-8">{label}</h5>

      <div>
        {(props.value || []).map((recruiterId) => (
          <Avatar
            plain
            class="mr-4"
            user={recruiters.find((r) => r.id === recruiterId)}
          />
        ))}
        <Dropdown
          element={({ close }) => (
            <UserSelectorPullout
              placeholder={placeholder}
              items={recruiters}
              selected={props.value || []}
              close={close}
              onChange={handleChange}
            />
          )}
        >
          <IconButton azure>plus</IconButton>
        </Dropdown>
      </div>
      {props.error && <span class="user-selector__error">{props.error}</span>}
    </div>
  );
}
